import classNames from "classnames";
import styles from "./JobList.module.css";
import { list } from "../../common/jobList/jobList.js";
import { useState } from "react";
import { Link } from "react-router-dom";
import arrow from "../../Img/jobPage/arrow.png";

const JobList = ({
  isDarkMode,
  isSidebar,
}: {
  isDarkMode: boolean;
  isSidebar: boolean;
}) => {
  const [positionName, setPositionName] = useState("전체");
  const [dropDown, setDropDown] = useState(false);
  const onClick = (e: any): void => {
    const target = e.target as HTMLElement;
    setPositionName(target.innerText.split(" ")[0]);
    setDropDown(false);
    return;
  };
  const isSelect = (position: string): boolean => {
    return positionName === position;
  };
  const onDropDown = (): void => {
    setDropDown(!dropDown);
    return;
  };

  return (
    <div className={styles.container}>
      {/*768px~480px responsibility dropDown*/}
      <div
        className={!isSidebar ? styles.dropDownMenu : styles.hide_dropDownMenu}
      >
        <div
          className={
            !isDarkMode ? styles.dropDownTitle : styles.dark_dropDownTitle
          }
          onClick={onDropDown}
        >
          {positionName === "전체"
            ? `전체 ${list.length}`
            : `${positionName} ${
                list.filter((data) => data.position === positionName).length
              }`}
          <img
            src={arrow}
            alt=""
            className={!dropDown ? styles.arrow : styles.activeArrow}
          />
        </div>
        {!isDarkMode && (
          <div
            className={
              !dropDown
                ? styles.inactivedropDownMenuList
                : styles.activedropDownMenuList
            }
          >
            <div
              className={classNames(
                isSelect("전체") ? styles.drop_active : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>전체</span> <span>{list.length}</span>
            </div>
            <div
              className={classNames(
                isSelect("개발") ? styles.drop_active : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>개발</span>
              <span>
                {list.filter((data) => data.position === "개발").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("디자인") ? styles.drop_active : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>디자인</span>
              <span>
                {list.filter((data) => data.position === "디자인").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("경영지원") ? styles.drop_active : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>경영지원</span>
              <span>
                {list.filter((data) => data.position === "경영지원").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("사업/마케팅")
                  ? styles.drop_active
                  : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>사업/마케팅</span>
              <span>
                {list.filter((data) => data.position === "사업/마케팅").length}
              </span>
            </div>
          </div>
        )}
        {isDarkMode && (
          <div
            className={
              !dropDown
                ? styles.dark_inactivedropDownMenuList
                : styles.dark_activedropDownMenuList
            }
          >
            <div
              className={classNames(
                isSelect("전체")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>전체</span> <span>{list.length}</span>
            </div>
            <div
              className={classNames(
                isSelect("개발")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>개발</span>
              <span>
                {list.filter((data) => data.position === "개발").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("디자인")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>디자인</span>
              <span>
                {list.filter((data) => data.position === "디자인").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("경영지원")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>경영지원</span>
              <span>
                {list.filter((data) => data.position === "경영지원").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("사업/마케팅")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>사업/마케팅</span>
              <span>
                {list.filter((data) => data.position === "사업/마케팅").length}
              </span>
            </div>
          </div>
        )}
      </div>

      <ul className={styles.positionList}>
        {!isDarkMode ? (
          <>
            {" "}
            <li
              onClick={onClick}
              className={classNames(
                isSelect("전체")
                  ? styles.activeAllPostion
                  : styles.inactiveAllPostion
              )}
            >
              전체 {list.length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("개발")
                  ? styles.activeDevelopPostion
                  : styles.inactiveDevelopPostion
              )}
            >
              개발 {list.filter((data) => data.position === "개발").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("디자인")
                  ? styles.activeDesignPostion
                  : styles.inactiveDesignPostion
              )}
            >
              디자인 {list.filter((data) => data.position === "디자인").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("경영지원")
                  ? styles.activeManagementPostion
                  : styles.inactiveManagementPostion
              )}
            >
              경영지원{" "}
              {list.filter((data) => data.position === "경영지원").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("사업/마케팅")
                  ? styles.activeMarketingPostion
                  : styles.inactiveMarketingPostion
              )}
            >
              사업/마케팅{" "}
              {list.filter((data) => data.position === "사업/마케팅").length}
            </li>
          </>
        ) : (
          /*DarkMode*/
          <>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("전체")
                  ? styles.darkactiveAllPostion
                  : styles.darkinactiveAllPostion
              )}
            >
              전체 {list.length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("개발")
                  ? styles.dark_activeDevelopPostion
                  : styles.dark_inactiveDevelopPostion
              )}
            >
              개발 {list.filter((data) => data.position === "개발").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("디자인")
                  ? styles.darkactiveDesignPostion
                  : styles.darkinactiveDesignPostion
              )}
            >
              디자인 {list.filter((data) => data.position === "디자인").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("경영지원")
                  ? styles.darkactiveManagementPostion
                  : styles.darkinactiveManagementPostion
              )}
            >
              경영지원{" "}
              {list.filter((data) => data.position === "경영지원").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("사업/마케팅")
                  ? styles.darkactiveMarketingPostion
                  : styles.darkinactiveMarketingPostion
              )}
            >
              사업/마케팅{" "}
              {list.filter((data) => data.position === "사업/마케팅").length}
            </li>
          </>
        )}
      </ul>
      <div
        className={classNames(
          !isDarkMode ? styles.proceedText : styles.darkproceedText
        )}
      >
        <span>
          {positionName}{" "}
          {
            list.filter((data) =>
              positionName === "전체"
                ? data.position
                : data.position === positionName
            ).length
          }
        </span>
        건의 채용이 진행 중 입니다.
      </div>
      <ul
        className={classNames(
          !isDarkMode ? styles.jobContainer : styles.darkjobContainer
        )}
      >
        {positionName === "전체" ? (
          <>
            {list.map((data) => (
              <Link to={`/position/${data.id}`} state={data} key={data.id}>
                <li className={styles.jobList} key={data.id}>
                  <div className={styles.type}>{data.type}</div>
                  <div className={styles.duty}>
                    {data.team} {data.duty}
                  </div>
                  <div className={styles.explain}>{data.explain}</div>
                  <ul className={styles.typeContainer}>
                    {data.tag.map((list, idx) => (
                      <li className={styles.tagList} key={idx}>
                        {list}
                      </li>
                    ))}
                  </ul>
                </li>
              </Link>
            ))}
          </>
        ) : (
          <>
            {list.map(
              (data) =>
                data.position === positionName && (
                  <Link to={`/position/${data.id}`} state={data} key={data.id}>
                    <li className={styles.jobList} key={data.id}>
                      <div className={styles.type}>{data.type}</div>
                      <div className={styles.duty}>
                        {data.team} {data.duty}
                      </div>
                      <div className={styles.explain}>{data.explain}</div>
                      <ul className={styles.typeContainer}>
                        {data.tag.map((list, idx) => (
                          <li className={styles.tagList} key={idx}>
                            {list}
                          </li>
                        ))}
                      </ul>
                    </li>
                  </Link>
                )
            )}
          </>
        )}
      </ul>
    </div>
  );
};

export default JobList;
